module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editKpiDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editKpiDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM2000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM2026) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2029) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedProject) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2027) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2028) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    on: {
      "change": function($event) {
        _vm.getClientProjectList(), _vm.getKpiGroupsOfSelectedClient()
      }
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                      " + _vm._s(client.ClientName) + "\n                    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.clientProjectList.length < 1,
      "placeholder": _vm.lang.KM2030,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.filterKpiGroupsByProject()
      }
    },
    model: {
      value: (_vm.selectedProjectGuid),
      callback: function($$v) {
        _vm.selectedProjectGuid = $$v
      },
      expression: "selectedProjectGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                      " + _vm._s(project.ProjectName) + "\n                    ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.KM2001,
      "allowClear": true,
      "disabled": !_vm.selectedProjectGuid || _vm.projectKpiGroupList.length < 1
    },
    on: {
      "change": function($event) {
        _vm.createNewKpi(), _vm.getKpisOfSelectedKpiGroup()
      }
    },
    model: {
      value: (_vm.selectedKpiGroupGuid),
      callback: function($$v) {
        _vm.selectedKpiGroupGuid = $$v
      },
      expression: "selectedKpiGroupGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projectKpiGroupList), function(kpiGroup) {
    return _c('option', {
      key: kpiGroup.KPIGroupGuid,
      domProps: {
        "value": kpiGroup.KPIGroupGuid
      }
    }, [_vm._v("\n                      " + _vm._s(kpiGroup.KPIGroupCode) + "\n                    ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2002) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2003) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2004) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGuid,
      class: {
        info: _vm.selectedKpiGuid === kpi.KPIGuid
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGuid = kpi.KPIGuid), _vm.getKpiData()
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpi.KPIGroupPosition) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(kpi.KPICode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v(_vm._s(kpi.KPIShortText))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-kpi-edit",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editKpiTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editKpiTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2005))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiOrderInKpiGroupTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'kpiOrderInKpiGroupTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2006))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editKpiTab"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiCode",
      "id": "inputKpiCodeLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2007) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPICode),
      expression: "selectedKpiInformation.KPICode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiCode",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPICode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPICode", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiCode')),
      expression: "inputHasError('inputKpiCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiCodeLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2037))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiShortText",
      "id": "inputKpiShortTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2008) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPIShortText),
      expression: "selectedKpiInformation.KPIShortText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputKpiShortText",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIShortText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIShortText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiShortText')),
      expression: "inputHasError('inputKpiShortText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiShortTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2034))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiLongText",
      "id": "inputKpiLongTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2009) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPILongText),
      expression: "selectedKpiInformation.KPILongText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiLongText",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPILongText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPILongText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiLongText')),
      expression: "inputHasError('inputKpiLongText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiLongTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2035))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiWeight",
      "id": "inputKpiWeightLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2032) + "\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.selectedKpiInformation.KPIWeight),
      expression: "selectedKpiInformation.KPIWeight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputKpiWeight",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === ''
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIWeight)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIWeight", _vm._n($event.target.value))
      }, function($event) {
        _vm.selectedKpiDirty = true
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiWeightLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2036))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIManagementSelectEvaluation"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIManagementSelectEvaluation",
      "placeholder": _vm.lang.KM2031,
      "allowClear": true,
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === ''
    },
    on: {
      "change": function($event) {
        _vm.selectedKpiDirty = true
      }
    },
    model: {
      value: (
        _vm.selectedKpiInformation.KPIEvaluationRuleGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.selectedKpiInformation, "KPIEvaluationRuleGuid", $$v)
      },
      expression: "\n                              selectedKpiInformation.KPIEvaluationRuleGuid\n                            "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.kpiEvaluationRulesList), function(evaluation) {
    return _c('option', {
      key: evaluation.EvaluationRuleGuid,
      domProps: {
        "value": evaluation.EvaluationRuleGuid
      }
    }, [_vm._v("\n                              " + _vm._s(evaluation.EvaluationRule) + "\n                            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2010))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPIDescription),
      expression: "selectedKpiInformation.KPIDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text",
      "maxlength": "500",
      "id": "inputKpiDescription",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === ''
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIDescription", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "25px 0 25px 0"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2012))])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid && !_vm.selectedKpiDirty
    },
    on: {
      "click": function($event) {
        return _vm.createNewKpi()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2013) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedKpiDirty
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid && !_vm.selectedKpiDirty
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editKpiDialog')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2014) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteKpiConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2015) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiOrderInKpiGroupTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM2016) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2017))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpi.KPIShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpi.KPIGroupPosition),
        expression: "kpi.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpi, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpisInKpiGroup(kpi.KPICode),
            (_vm.changeKpiOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi2) {
      return _c('option', {
        key: kpi2.KPIGroupPosition,
        domProps: {
          "value": kpi2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpi2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpisOfSelectedKpiGroup.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpisNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM2033) + "\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM2018) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f92d4a34","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KPIManagement/KPIManagementEditModal.vue
// module id = 1735
// module chunks = 1